import React from 'react';

const ToggleSwitch = ({ isActive, onToggle }) => {
    return (
        <div className="toggle">
            <button className={`toggle__switch ${isActive ? 'toggle__switch--active' : ''}`} onClick={onToggle}>
                <div className="toggle__circle" />
            </button>
            <span className={`toggle__label ${isActive ? 'toggle__label--active' : ''}`}>Active</span>
        </div>
    );
};

export default ToggleSwitch;
